import { purgeOversizedEvercookies } from "~/utils/evercookieCodec";

export default async ({ app, store, $axios, $grom }) => {
    if (store.getters["wishlist/getIds"].length == 0) {
        await store.dispatch("wishlist/setIds");
    }
    if (!store.getters["wishlist/items"]) {
        await store.dispatch("order/setOrder");
    }

    let lang =
        document.cookie.split(";").filter((q) => {
            return q.indexOf("i18n_redirected") >= 0;
        })?.[0] || "ru";

    if (lang) {
        lang = lang.split("=")[1];
    } else {
        lang = "ru";
    }
    $axios.setHeader("Accept-Language", lang);

    window.onNuxtReady(async () => {
        if (process.client) {
            // снести разросшиеся/битые evercookie-значения до того, как библиотека начнёт голосование
            purgeOversizedEvercookies();

            // set evercooke
            window.ec = new window.evercookie({
                java: false,
                silverlight: false,
                lso: false,
                authPath: false,
                phpuri: "/api/evercookie",
                pngPath: "/png",
                etagPath: "/etag",
                cachePath: "/cache",
                history: false,
            });

            $grom.checkEverCookie();

            const headerClassList = document.querySelector("#app").classList;
            window.addEventListener("scroll", function () {
                if (this.oldScroll > this.scrollY) {
                    headerClassList.remove("is_scrolled");
                } else {
                    if (this.scrollY > 36) {
                        headerClassList.add("is_scrolled");
                    }
                }
                this.oldScroll = this.scrollY;
            });
        }

        document.querySelector("body").classList.add("app-lang-" + app.i18n.localeProperties.code);
        store.dispatch("globalvars/getLanguagesAndCurrencies");
        store.dispatch("catalog/getLastViewed");

        // [...document.querySelectorAll('a[href*="tel"]')].forEach((el) => {
        //     el.addEventListener("click", () => {
        //         ga("send", "event", "phone", "click");
        //     });
        //     el.addEventListener("copy", () => {
        //         ga("send", "event", "phone", "copy");
        //     });
        // });
        // [...document.querySelectorAll('a[href*="mailto"]')].forEach((el) => {
        //     el.addEventListener("click", () => {
        //         ga("send", "event", "email", "click");
        //     });
        //     el.addEventListener("copy", () => {
        //         ga("send", "event", "email", "copy");
        //     });
        // });
        console.log("%c%s", "color: green", "Make with ❤ by Grom IT");
    });
};
